<template>
  <div>
    <content-item class="tags_list">
      <h2 :class="{ 'invalid': !!formatLabelsError }">{{ formatLabelTitle }}</h2>
      <span v-if="!!formatLabelsError" class="invalid">
        {{ formatLabelsError.msg }}
      </span>
      <ul>
        <app-radio-button
          v-for="tag in formatLabelsChecked"
          labels
          :title="tag.name"
          :key="tag._id"
          v-model="tagFormatId"
          :value="tag._id"
          :disabled="pending || disabled"
          :error="!!formatLabelsError"
          name="formatLabelId"
        />
      </ul>
      <ul>
        <app-radio-button
          v-for="tag in formatLabelsNotChecked"
          labels
          :title="tag.name"
          :key="tag._id"
          v-model="tagFormatId"
          :value="tag._id"
          :disabled="pending || disabled"
          :error="!!formatLabelsError"
          name="formatLabelId"
        />
      </ul>
    </content-item>

    <show-checkbox-list
      :sectionName="contentLabelTitle"
      :values="localContentLabels"
      @change="contentLabelsChanged"
    />
    <show-checkbox-list
      :sectionName="countryTitle"
      :values="localCountries"
      :searchField="true"
      @change="countriesChanged"
    />
  </div>
</template>

<script>
import ContentItem from './ContentItem'
import DropdownInput from '@/components/DropdownInput'
import { AUTOCOMPLETE_TITLE } from '@/symbols/autocomplete'
import ShowCheckboxList from '../../Filter/ShowCheckboxList.vue'

export default {
  name: 'information-tags',
  components: {
    DropdownInput,
    ContentItem,
    ShowCheckboxList
  },
  props: {
    formatLabels: {
      type: Object,
      required: true
    },
    contentLabels: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    countries: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    pending: {
      type: Boolean,
      default: false
    },
    errorsProp: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.updateTagFormatId()
  },
  data() {
    return {
      tagFormatId: null,
      localContentLabels: [],
      localCountries: []
    }
  },
  computed: {
    formatLabelsChecked() {
      return this.filterTags(this.formatLabels, true)
    },
    formatLabelsNotChecked() {
      return this.filterTags(this.formatLabels, false)
    },
    formatLabelTitle() {
      return this.$gettext('Štítky - formát *')
    },
    contentLabelTitle() {
      return this.$gettext('Štítky - obsah')
    },
    countryTitle() {
      return this.$gettext('Státy')
    },
    formatLabelsError() {
      return this.errorsProp.items.find(el => el.field === 'formatLabelId')
    }
  },
  methods: {
    contentLabelsChanged() {
      this.$emit('contentLabelsChanged', this.localContentLabels)
    },
    removeContentLabel(item) {
      if (item !== null) {
        this.localContentLabels.filter(v => v.labelName === item)[0]['checked'] = false
        this.localContentLabels = [...this.localContentLabels]
      }
      this.contentLabelsChanged()
    },
    removeAllContentLabels() {
      this.localContentLabels.forEach((v) => {
        v['checked'] = false
      })
      this.localContentLabels = [...this.localContentLabels]
      this.contentLabelsChanged()
    },
    contentLabelSelected(id) {
      if (id !== null) {
        this.localContentLabels.filter(v => v._id === id)[0]['checked'] = true
        this.localContentLabels = [...this.localContentLabels]
        this.contentLabelsChanged()
      }
      window.setTimeout(function () {
        document.getElementById('note').focus({
          preventScroll: true
        })
      }, 0)
    },
    isContentLabelEmpty() {
      return this.localContentLabels.filter(v => v.checked === true).length == 0
    },
    countriesChanged() {
      this.$emit('countriesChanged', this.localCountries)
    },
    removeCountry(item) {
      if (item !== null) {
        this.localCountries.filter(v => v.countryName === item)[0]['checked'] = false
        this.localCountries = [...this.localCountries]
      }
      this.countriesChanged()
    },
    removeAllCountries() {
      this.localCountries.forEach((v) => {
        v['checked'] = false
      })
      this.localCountries = [...this.localCountries]
      this.countriesChanged()
    },
    countrySelected(id) {
      if (id !== null) {
        this.localCountries.filter(v => v._id === id)[0]['checked'] = true
        this.localCountries = [...this.localCountries]
        this.countriesChanged()
        window.setTimeout(function () {
          document.getElementById('note').focus({
            preventScroll: true
          })
        }, 0)
      }
    },
    isCountryEmpty() {
      return this.localCountries.filter(v => v.checked === true).length == 0
    },
    filterTags(tags, checked) {
      const arr = []
      Object.keys(tags).forEach(v => {
        if (tags[v].checked === checked) {
          arr.push(tags[v])
        }
      })
      return arr
    },
    filterAndSetFormatTag(formatLabels) {
      this.refreshTagFormatId(this.filterTags(formatLabels, true))
    },
    updateTagFormatId() {
      if (this.formatLabelsChecked.length > 0) {
        // noinspection JSPotentiallyInvalidTargetOfIndexedPropertyAccess
        this.tagFormatId = this.formatLabelsChecked[0]._id
      } else {
        this.tagFormatId = null
      }
    },
    setTagFormatId(formatId) {
        this.tagFormatId = formatId;
    },
    isTagFormatIdEmpty() {
        return this.tagFormatId == null;
    },
    resetTagFormat() {
        this.tagFormatId = null;
    },
    refreshTagFormatId(formatLabelsChecked) {
      if (formatLabelsChecked.length > 0) {
        this.tagFormatId = formatLabelsChecked[0]._id
      } else {
        this.tagFormatId = null
      }
    },
    addCheckedAttribute(values) {
      values.forEach((v) => {
        if (v.checked === undefined) {
          v.checked = false
        }
      })
    }
  },
  watch: {
    formatLabels() {
      this.updateTagFormatId()
    },
    tagFormatId(v) {
      this.$emit('formatTagChanged', v)
    },
    contentLabels() {
      this.addCheckedAttribute(this.contentLabels)
      this.localContentLabels = [...this.contentLabels]
    },
    countries() {
      this.addCheckedAttribute(this.countries)
      this.localCountries = [...this.countries]
    }
  }
}
</script>
